import React from "react";
import { Modal } from "react-bootstrap";

const MachineNameUpdateModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Confirmation
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Machine name is different. Please confirm if you wish to proceed with
          the update.
        </p>
        <p>
          Current Machine Name:{" "}
          <b>{props?.detail?.dataList1?.[0]?.machinename}</b>
        </p>
        <p>
          New Machine Name: <b>{props?.zipdetail?.machinename}</b>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button className="grey-btn w-auto" onClick={props.onHide}>
          Cancel
        </button>
        <button className="blue-btn w-auto" onClick={props.confirmkey}>
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MachineNameUpdateModal;
